<template>
  <div class="order" v-if="ss">
    <Detail />
    <!-- <div
      style="
        margin-top: 20px;
        border-radius: 20px;
        box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
      "
    > -->
    <van-tabs
      v-model="active"
      type="card"
      color="#009fff"
      line-width="70px"
      style="border: 1px solid #ffffff; margin-top: 15px"
      @change="changse"
    >
      <van-tab title="余额减少"></van-tab>
      <van-tab title="余额增加"></van-tab>
    </van-tabs>
    <!-- </div> -->
    <div class="detail" v-for="item in msg" :key="item.id">
      <div
        style="
          font-size: 17px;
          font-weight: 700;
          padding: 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          style="
            text-align: start;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ active == 0 ? "余额减少" : "余额增加" }}
        </span>
        <span style="color: #009fff">{{ item.balance }}元</span>
      </div>
      <van-collapse v-model="activeNames" style="padding: 0 10px">
        <van-collapse-item
          :border="false"
          style="text-align: left; border-top: 1px solid #c5e1ff"
          :title="'变动时间:' + item.addTime"
          :name="item.id"
        >
          <div>
            <table
              style="
                width: 100%;
                border: 1px solid rgb(200, 200, 200);
                border-collapse: collapse;
              "
            >
              <tr>
                <td class="tds">变更前余额</td>
                <td class="td">{{ item.addBalance }}元</td>
              </tr>
              <tr>
                <td class="tds">变更余额</td>
                <td class="td">{{ item.balance }}元</td>
              </tr>
              <tr>
                <td class="tds">变更后余额</td>
                <td class="td">{{ item.endBalance }}元</td>
              </tr>
            </table>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
  import { Loading } from "element-ui";
  import Detail from "@/components/Detail.vue";

  import { phoneBill } from "@/api/cardOperation";

  export default {
    data() {
      return {
        active: 0,
        msg: [],
        activeNames: ["1"],
        ss: false,
        s: false,
      };
    },
    created() {},
    mounted() {
      this.changse();
      Loading.service();
    },
    methods: {
      changse() {
        phoneBill(this.active).then((res) => {
          if (res.status) {
            this.msg = res.data;
            this.card = this.$route.params.card;
            this.ss = true;
            Loading.service().close();
            if (this.msg.length == 0) {
              this.s = true;
            } else {
              this.s = false;
            }
          }
        });
      },
    },
    components: {
      Detail,
    },
  };
</script>

<style lang="scss" scoped>
  .van-tabs__nav .van-tabs__nav--card {
    margin: 0;
    border: 0;
  }
  .tds {
    width: 50%;
    border: 1px solid rgb(190, 190, 190);
    border-right: 0;
    padding: 10px 10px;
  }
  .td {
    width: 50%;
    border: 1px solid rgb(190, 190, 190);
    padding: 10px 10px;
  }
  .order {
    // background-color: rgba(128, 128, 128, 0.1);
    padding: 15px;
    .detail {
      width: 100%;
      margin: 15px 0;
      border-radius: 10px;
      padding-bottom: 15px;
      box-sizing: border-box;

      border: 1px solid #c5e1ff;
    }
  }
</style>
